import { ChatMessageBase } from './chat-message-base';

/**
 * TextChatMessage model
 * @param textChatMessage
 *  <fields>
 <field name="TextChatMessageID"      type="long" generateIfNull="true"/>
 <field name="PersonType"             type="int"/>
 <field name="PersonID"               type="long"/>
 <field name="Name"                   type="text"/>
 <field name="Text"                   type="text"/>
 <field name="TextChatID"             type="long"/>
 <field name="Created"                type="datetime" size="255"/>
 <field name="Deleted"                type="datetime"/>
 <field name="AccountID"              type="long"/>
 <field name="CannedMessageID"        type="long"/>
 <field name="LastIncomingArrived"    type="datetime"/>
 *  </fields>
 *
 * @constructor
 */

class TextChatMessage extends ChatMessageBase {
  public TextChatMessageID?: number;
  public PersonType?: number;
  public PersonID?: number;
  public Name?: string;
  public Text?: string;
  public TextChatID?: number;
  public Created?: string;
  public Deleted?: string;
  public AccountID?: number;
  public CannedMessageID?: number;
  public LastIncomingArrived?: string;
  public JsonData?: string;

  static comparator(textChatMessage1, textChatMessage2) {
    return textChatMessage1.TextChatMessageID === textChatMessage2.TextChatMessageID;
  }
}

function factory() {
  return TextChatMessage;
}

export { TextChatMessage, factory };
